<template>
  <!-- ЕСЛИ УЖЕ СОЗДАН ТОИППР -->
  <template v-if="doc.has_toir">
    <v-avatar class="mr-1" v-on:click="select_doc()" :style="`${get_gradient()}; opacity: ${!is_filtered() ? 0.1 : 0.3}`" style="cursor: pointer" variant="tonal" color="grey" size="20">
      <v-avatar variant="flat" size="16"  :color="is_selected ? 'green' : 'white'"  class="font-weight-bold" style="font-size: 10px">
        {{ doc.number }}
      </v-avatar>
    </v-avatar>
  </template>

  <!-- ЕСЛИ НЕТ -->
  <template v-else>
    <v-card height="20" v-on:click="select_doc()" rounded="md"
            class="mr-1 d-flex justify-center align-center" variant="flat"
            elevation="0" :class="{ 'hidden' : !is_filtered() }"
            :color="is_selected ? 'green' : 'grey-lighten-2'"
            v-on:mouseenter="mark_hover" v-on:mouseleave="unmark_hover"
            :style="`${get_gradient()}; opacity: ${!is_filtered() ? 0.3 : 1}`"
    >
      <v-card height="16" min-width="24" rounded="md"
              class="d-flex justify-center align-center"
              variant="flat" elevation="0" style="margin: 2px;"
              :color="is_selected ? 'green' : (is_to ? 'grey-lighten-2' : 'amber-lighten-2')"
      >
        {{ doc.number }}
      </v-card>
    </v-card>
  </template>
</template>

<script>
import { Documents } from "@/store/zn_planner/Documents"
import { ZN_SelDoc } from "@/store/a_planner/SelectedDOC"
import { ZN_Filters } from "@/store/zn_planner/Filters"

export default {
  name: 'ZN_Chip',
  props: ['doc', 'day', 'editable'],
  data() {
    return {
      hovering: null
    }
  },
  beforeMount() {
    addEventListener('keydown', this.delete_event)
  },
  methods: {
    get_gradient: function () {
      let period = this.doc.period
      let s
      switch (period) {
        case 'Квартал':
          s = 100 / 4
          break
        case 'Полугодие':
          s = 100 / 2
          break
        case 'Год':
          s = 100
          break
        case 'Месяц':
          s = 100 / 12
          break
        default:
          s = 0
          break
      }
      return `background: conic-gradient(${this.is_to ? '#9d9d9d' : '#cea215'} 0% ${s}%, ${'rgba(0,0,0,0)'} ${s}% 100%) !important`
    },
    select_doc: function () {
      this.document_preview = this.doc
    },
    delete_event: function (event) {
      if (this.hovering && !this.doc.has_toir) {
        if (event.keyCode === 46) {
          this.remove_doc(this.day, this.doc)
          removeEventListener('keydown', this.delete_event)
        }
      }
    },
    mark_hover: function () {
      if (!this.doc.has_toir && this.editable) {
        this.hovering = true
      }
    },
    unmark_hover: function () {
      if (!this.doc.has_toir && this.editable) {
        this.hovering = false
      }
    },
    remove_doc: function (day, doc) {
      this.documents.unshift(doc)

      day.documents.splice(day.documents.findIndex(d => d.guid === doc.guid), 1)
      day.hours.used -= doc.duration
      day.hours.free += doc.duration
    },
    is_filtered() {
      if (this.filters) {
        let agents = this.filters.agents
        let objects = this.filters.objects
        let types = this.filters.types
        let period = this.filters.period
        let chief = this.filters.chiefs

        let has_agents = agents.length > 0 ? agents.includes(this.doc.agent.guid) : true
        let has_objects = objects.length > 0 ? objects.includes(this.doc.object.guid) : true
        let has_types = types.length > 0 ? types.includes(this.doc.type.guid) : true
        let has_period = period.length > 0 ? period.includes(this.doc.period) : true
        let has_chief = chief.length > 0 ? chief.includes(this.doc.chief.guid) : true

        return has_agents && has_objects && has_types && has_period && has_chief
      } else {
        return true
      }
    }
  },
  computed: {
    is_selected() {
      return this.document_preview && this.doc.guid === this.document_preview.guid
    },
    is_to() {
      return this.doc.type.name === 'Техническое обслуживание'
    },
    documents: {
      get() {
        return Documents().get()
      },
      set(value) {
        Documents().set(value)
      }
    },
    filters: {
      get() {
        return ZN_Filters().get()
      },
      set(value) {
        ZN_Filters().set(value)
      }
    },
    document_preview: {
      get() {
        return ZN_SelDoc().get()
      },
      set(value) {
        ZN_SelDoc().set(value)
      }
    }
  }
}

</script>
